<template>
  <div class="GoodsCombinationDetails">
    <div class="product-con">
      <div class="endtime">
        距离结束还剩
        <span  class="bg-color font-color-fff"
          >{{countDownDay}}</span
        >: <span class="bg-color font-color-fff">{{countDownHour}}</span>:
        <span class="bg-color font-color-fff">{{countDownMinute}}</span>
        <span class="bg-color font-color-fff">{{countDownSecond}}</span>
      </div>
      <div class="bg-fff">
        <productConSwiper :imgUrls="imgUrls"></productConSwiper>
      </div>
      <div class="wrapper">
        <div class="introduce">{{storeInfo.title}}</div>
        <div class="share acea-row row-between row-bottom">
          <div class="money">
            ￥<span class="num">{{storeInfo.price}}</span>
            <span class="y-money">单买价￥{{storeInfo.product_price}}</span>
          </div>
          <button
            @click="listenerActionSheet"
            class="iconfont icon-fenxiang"
            ></button>
        </div>
        <div class="label acea-row row-between-wrapper">
          <div class="stock">类型：{{storeInfo.people}}人团</div>
          <div>累计销量：{{storeInfo.total?storeInfo.total:0}}件</div>
          <div>限购:{{ storeInfo.quota_show ? storeInfo.quota_show : 0 }}件</div>
        </div>
      </div>
      <div class="attribute acea-row row-between-wrapper" @click="selecAttr" v-if="productAttr.length">
        <div>已选择：<span class="atterTxt">{{attrValue}}</span></div>
        <div class="iconfont icon-jiantou"></div>
      </div>
      <div class="assemble">
        <div class="assemble-child">
          <div class="notice acea-row row-middle">
            <div class="num font-color">
              <span class="iconfont icon-laba"></span>
              已拼{{pink_ok_sum}}件<span class="line">|</span>
            </div>
            <div class="swiper swiper-wrapper">
              <swiper class="swiper-wrapper" :options="swiperNew">
                <swiperSlide 
                  class="swiper-slide"
                  v-for="(item,index) in itemNew"
                  :key="index"
                  >
                  <div class="line1">{{item}}</div>
                </swiperSlide>
              </swiper>
            </div>
          </div>
          <div 
            v-for="(item,index) in pink"
            :key="index">
            <div 
            class="item acea-row row-between-wrapper"
            v-if="index < AllIndex"
            >
            <div class="pictxt acea-row row-between-wrapper">
              <div class="pictrue"><img :src="item.avatar"></div>
              <div class="text line1">{{item.nickname}}</div>
            </div>
            <div class="right acea-row row-middle">
              <div>
                <div class="lack">
                  还差<span class="font-color">{{item.count}}</span>人成团
                </div>
                <div class="time">剩余{{item.time&&item.time.hou?item.time.hou:'00'}}:{{item.time&&item.time.min?item.time.min:'00'}}:{{item.time&&item.time.sec?item.time.sec:'00'}}</div>
              </div>
              <div
                hover-class="none"
                url="/pages/activity/goods_combination_status/index?id="
                class="spellBnt"
                @click="goCombination(item)"
                >去拼单<span class="iconfont icon-jiantou"></span
              ></div>
            </div>
          </div>
          </div>
          <div
            class="more"
            @click="showAll"
            v-if="pink.length >= AllIndex"
          >查看更多<span class="iconfont icon-xiangxia"></span>
          </div>
          <div
            class="more"
            @click="hideAll"
            v-if="pink.length >= AllIndex && !pink.length"
          >
            收起<span class="iconfont icon-xiangxia"></span>
          </div>
        </div>
      </div>
      <!-- 团购人头像 -->
      <div class="assemble-img" v-if="pink_ok_num">
        <div class="assemble-img-child">
          <span class="assemble-tit">超过{{pink_ok_num}}人参与了该团购</span>
          <div class="assemble-head-img">
            
              <img v-for="(item,index) in pink_ok_user" :key="index" :src="item" mode="widthFix">
            
          </div>
        </div>
      </div>
      <!-- 团购人头像 end-->
      <div class="playWay">
        <div class="title acea-row row-between-wrapper">
          <div>拼团玩法</div>
          
        </div>
        <div class="way acea-row row-middle">
          <div class="item"><span class="num">①</span>开团/参团</div>
          <div class="iconfont icon-arrow"></div>
          <div class="item"><span class="num">②</span>邀请好友</div>
          <div class="iconfont icon-arrow"></div>
          <div class="item">
            <div><span class="num">③</span>满员发货</div>
            <!-- <div class='tip'>不满自动退款</div> -->
          </div>
        </div>
      </div>
      <div class="userEvaluation" wx:if="">
        <userEvaluation reply=""></userEvaluation>
      </div>
      <div class="product-intro">
        <div class="title">产品介绍</div>
        <div class="conter" v-html="storeInfo.description">
          
        </div>
      </div>
      <div style="height: 1.2rem"></div>
      <div class="footer acea-row row-between-wrapper">
        <!-- <button
          open-type="contact"
          business-id=""
          hover-class="none"
          class="item"
        >
          <div class="iconfont icon-kefu"></div>
          <div>客服</div>
        </button> -->
        <!-- <div bindtap="setCollect" class="item">
          <div class="iconfont icon-shoucang1"></div>
          <div class="iconfont icon-shoucang"></div>
          <div>收藏</div>
        </div> -->
        <div class="bnt acea-row">
          <div class="joinCart bnts" @click="goProduct">单独购买</div>
          <div
            @click="goCat"
            v-if="storeInfo.quota >= 0 && storeInfo.product_stock >= 0"
            class="buy bnts bg-color">立即开团</div>
          <div 
            v-else-if="storeInfo.quota <= 0 || storeInfo.product_stock <=0 "
            class="buy bnts bg-color-hui">
            已售罄
          </div>
        </div>
        <!-- <div class='bnt bg-color' style='width:43%;background: #ff6d40;' bindtap='goProduct'>原价购买</div>
        <div class='bnt bg-color' style='width:43%' bindtap='goCat'>立即开团</div> -->
      </div>
    </div>
    <div
      class="generate-posters acea-row row-middle"
      :class="posters ? 'on' : ''"
    >
      <div
        class="item"
        v-if="weixinStatus === true"
        @click="setShareInfoStatus"
      >
        <div class="iconfont icon-weixin3"></div>
        <div class="">发送给朋友</div>
      </div>
      <!-- <div class="item" @click="setPosterImageStatus">
        <div class="iconfont icon-haibao"></div>
        <div class="">生成海报</div>
      </div> -->
    </div>
    <div
      class="mask"
      @touchmove.prevent
      @click="listenerActionClose"
      v-show="posters"
    ></div>
    <Product-window
      v-on:changeFun="changeFun"
      :attr="attr"
      :iSplus="iSplus"
    ></Product-window>
    <ShareInfo
      v-on:setShareInfoStatus="setShareInfoStatus"
      :shareInfoStatus="shareInfoStatus"
    ></ShareInfo>
  </div>
</template>
<script>
import { getCombinationDetail } from "@api/activity";
import { getUserInfo } from "@api/user";
import { imageBase64 } from "@api/public";
import {postCartAdd} from "@api/store";
import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
import { wechatEvevt } from "@libs/wechat";
import ProductConSwiper from "@components/ProductConSwiper";
import ShareInfo from "@components/ShareInfo";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import ProductWindow from "@components/ProductWindow";
import "@assets/css/swiper.min.css";
export default {
  name: "GoodsCombinationDetails",
  components: {
    ProductConSwiper,
    swiper,
    swiperSlide,
    ProductWindow,
    ShareInfo,
  },
  data() {
    return {
      parameter: {
        navbar: "1",
        return: "1",
        title: "一起来拼团",
        color: true,
        class: "on",
      },
      imgUrls: [],
      userInfo: {},
      storeInfo: {},
      pink: [],
      pindAll: [],
      reply: "",
      replyCount: 0,
      itemNew: [],
      replyChance: "",
      productAttr: [],
      productValue: [],
      pink_ok_num: 0,
      pink_ok_user: [],
      pink_ok_sum:"",
      countdownTime: {
        start_time: 0,
        stop_time: 0,
      },

      id: 0,
      swiperNew: {
        direction: "vertical",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000,
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
      },
      iSplus: true,
      attr: {
        cartAttr: false,
        productAttr: [],
        productSelect: {},
      },
      attrValue: "",
      isOpen: false, //是否打开属性组件
      countDownDay: "00",
      countDownHour: "00",
      countDownMinute: "00",
      countDownSecond: "00",

      weixinStatus: false,
      posters: false,
      AllIndex:3,
      timeer:null,
    };
    
  },
  computed: mapGetters(["isLogin"]),
  created() {
    if (this.$route.query.hasOwnProperty("id")) {
      this.id = this.$route.query.id;
    } else {
      this.$dialog.error("参数错误");
    }
  },
  mounted() {
    
    this.getUserInfo();

    this.combinationDetail();
  },
  // destroyed(){
  //   this.interval && clearInterval(interval)
  // },
  methods: {
    ccc() {
      console.log(this.$route.query.id);
    },
    changeFun: function (opt) {
      if (typeof opt !== "object") opt = {};
      let action = opt.action || "";
      let value = opt.value === undefined ? "" : opt.value;
      this[action] && this[action](value);
    },
    changeattr: function (msg) {
      this.attr.cartAttr = msg;
      this.isOpen = false;
    },
    tapBuy: function () {
      //  1=直接购买
      this.goCat(1);
    },
    goCat: function (news) {
      let that = this;
      let productSelect = that.productValue[this.attrValue];
      //打开属性
      if (that.attrValue) {
        //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
        that.attr.cartAttr = !that.isOpen ? true : false;
      } else {
        if (that.isOpen) that.attr.cartAttr = true;
        else that.attr.cartAttr = !that.attr.cartAttr;
      }
      //只有关闭属性弹窗时进行加入购物车
      if (that.attr.cartAttr === true && that.isOpen === false)
        return (that.isOpen = true);
        
      if (
        !this.attr.productSelect.cart_num ||
        parseInt(this.attr.productSelect.cart_num) <= 0
      )
        return that.$dialog.toast({ mes: "请输入购买数量" });
      //如果有属性,没有选择,提示用户选择
      if (
        that.attr.productAttr.length &&
        productSelect === undefined &&
        that.isOpen === true
      )
        return that.$dialog.toast({ mes: "产品库存不足，请选择其它" });
      let q = {
        productId: that.storeInfo.product_id,
        secKillId: 0,
        bargainId: 0,
        combinationId: that.id,
        cartNum: that.attr.productSelect.cart_num,
        uniqueId:productSelect !== undefined?productSelect.unique: "",
      };
      
      postCartAdd(q)
        .then(function (res) {
          
          that.isOpen = false;
          // that.attr.cartAttr = false;
          that.$router.push({
            path:`/order/submit/${res.data.cartId}`
          })
        })
        .catch(res => {
          that.isOpen = false;
          return that.$dialog.toast({ mes: res.msg });
        });
    },
    getUserInfo() {
      //获取用户信息
      let that = this;
      getUserInfo().then((res) => {
        that.userInfo = res.data;
      });
    },
    combinationDetail() {
      //获取详情
      let that = this;
      let data = that.id;
      getCombinationDetail(data).then((res) => {
        that.parameter.title = res.data.storeInfo.title;
        that.imgUrls = res.data.storeInfo.images;
        that.storeInfo = res.data.storeInfo;
        that.pink = res.data.pink;
        that.pindAll = res.data.pindAll;
        that.reply = [res.data.reply];
        that.replyCount = res.data.replyCount;
        that.itemNew = res.data.pink_ok_list;
        that.pink_ok_sum = res.data.pink_ok_sum;
        that.replyChance = res.data.replyChance;
        that.productAttr = res.data.productAttr;
        that.productValue = res.data.productValue;
        that.pink_ok_num = res.data.pink_ok_num;
        that.pink_ok_user = res.data.pink_ok_user;
        that.countdownTime.start_time = res.data.storeInfo.start_time;
        that.countdownTime.stop_time = res.data.storeInfo.stop_time;
        that.setTime();
        that.time2(res.data.storeInfo.stop_time, that);
        that.attr.productSelect.quota_show = res.data.storeInfo.quota_show
        that.DefaultSelect();
        that.setOpenShare();
      }).catch(res =>{
        this.$dialog.error(res.msg);
        this.$router.go(-1);
      })
    },
    
    time2(timeStamp, that) {
      var totalSecond = timeStamp - Date.parse(new Date()) / 1000;
      var interval = setInterval(
        function () {
          // 秒数
          var second = totalSecond;
          // // 天数位
          var day = Math.floor(second / 3600 / 24);
          var dayStr = day.toString();
          if (dayStr.length == 1) dayStr = "0" + dayStr;
          // 小时位
          var hr = Math.floor((second - day * 3600 * 24) / (60 * 60));
          var hrStr = hr.toString();
          if (hrStr.length == 1) hrStr = "0" + hrStr;

          // 分钟位
          // var min = Math.floor((second - hr * 3600) / 60);
          var min = Math.floor((second - day * 3600 * 24 - hr * 3600) / 60);
          var minStr = min.toString();
          if (minStr.length == 1) minStr = "0" + minStr;

          // 秒位
          // var sec = second - hrNew * 3600 - min * 60;
          var sec = Math.floor(second - day * 3600 * 24 - hr * 3600 - min * 60);
          var secStr = sec.toString();
          if (secStr.length == 1) secStr = "0" + secStr;
          that.countDownDay = dayStr;
          that.countDownHour = hrStr;
          that.countDownMinute = minStr;
          that.countDownSecond = secStr;
          totalSecond--;
          if (totalSecond <= 0) {
            clearInterval(interval);
            that.$dialog.error("活动已结束")
            if(window.history.length <= 1){
              setTimeout(()=>{
                this.$router.push({
                path:'/'
                })
              },500)
            }else{
              setTimeout(()=>{
                this.$router.go(-1);
              },500)
            }
            that.countDownDay = "00";
            that.countDownHour = "00";
            that.countDownMinute = "00";
            that.countDownSecond = "00";
          }
        }.bind(that),
        1000
      );

      that.interval = interval;
    },
    listenerActionSheet: function() {
      if (isWeixin() === true) {
        this.weixinStatus = true;
      }
      this.posters = true;
    },
    listenerActionClose(){
      this.posters = false;
    },
    setShareInfoStatus: function() {
      this.shareInfoStatus = !this.shareInfoStatus;
      this.posters = false;
    },
    setPosterImageStatus: function() {
        this.getImageBase64();
    },
    getImageBase64: function() {
      let that = this;
      imageBase64(this.posterData.image, that.posterData.code)
        .then(res => {
          that.posterData.image = res.data.image;
          that.posterData.code = res.data.code;
          that.isLogin && that.shareCode();

          // 生成海报
          var sTop = document.body || document.documentElement;
          sTop.scrollTop = 0;
          that.posterImageStatus = !that.posterImageStatus;
          that.posters = false;
        })
        .catch(() => {
          that.isLogin && that.shareCode();
        });
    },
    goProduct(){
      this.$router.push({
        path:`/detail/${this.storeInfo.product_id}`
      })
    },
    //默认选中属性；
    DefaultSelect(){
      let productAttr = this.attr.productAttr,
        value = [];
      for (var key in this.productValue) {
        if (this.productValue[key].stock > 0) {
          value = this.attr.productAttr.length ? key.split(",") : [];
          break;
        }
      }
      for (let i = 0; i < productAttr.length; i++) {
        this.$set(productAttr[i], "index", value[i]);
      }
      //sort();排序函数:数字-英文-汉字；
      let productSelect = this.productValue[value.sort().join(",")];
      
      if (productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.title
        ); 
        this.$set(this.attr.productSelect, "image", productSelect.image);
        this.$set(this.attr.productSelect, "price", productSelect.price);
        this.$set(this.attr.productSelect, "stock", productSelect.stock);
        this.$set(this.attr.productSelect, "unique", productSelect.unique);
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", value.sort().join(","));
        this.$set(this, "attrTxt", "已选择");
      } else if (!productSelect && productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.title
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", 0);
        this.$set(this.attr.productSelect, "unique", "");
        this.$set(this.attr.productSelect, "cart_num", 0);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      } else if (!productSelect && !productAttr.length) {
        this.$set(
          this.attr.productSelect,
          "store_name",
          this.storeInfo.title
        );
        this.$set(this.attr.productSelect, "image", this.storeInfo.image);
        this.$set(this.attr.productSelect, "price", this.storeInfo.price);
        this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
        this.$set(
          this.attr.productSelect,
          "unique",
          this.storeInfo.unique || ""
        );
        this.$set(this.attr.productSelect, "cart_num", 1);
        this.$set(this, "attrValue", "");
        this.$set(this, "attrTxt", "请选择");
      }
    },
    //购物车；
    ChangeCartNum: function(changeValue) {
      
      //changeValue:是否 加|减
      //获取当前变动属性
      let productSelect = this.productValue[this.attrValue];
      //如果没有属性,赋值给商品默认库存
      if (productSelect === undefined && !this.attr.productAttr.length);
        
        productSelect = this.attr.productSelect;
        
      //无属性值即库存为0；不存在加减；
      if (productSelect === undefined) return;
      
      let quota_show = productSelect.quota_show || 0;
      
      let num = this.attr.productSelect;
      
      if (changeValue) {
        num.cart_num++;
        if (num.cart_num > quota_show) {
          this.$set(this.attr.productSelect, "cart_num", quota_show ? quota_show : 1);
          this.$set(this, "cart_num", quota_show ? quota_show : 1);
        }
      } else {
        num.cart_num--;
        if (num.cart_num < 1) {
          this.$set(this.attr.productSelect, "cart_num", 1);
          this.$set(this, "cart_num", 1);
        }
      }
    },
    setTime() {//到期时间戳
    var that = this;
    var endTimeList = that.pink;
    var countDownArr = [];
    var timeer=setInterval(function(){
      var newTime = new Date().getTime() / 1000;
      for (var i in endTimeList) {
        var endTime = endTimeList[i].stop_time;
        var obj = [];
        if (endTime - newTime > 0) {
          var time = endTime - newTime;
          var day = parseInt(time / (60 * 60 * 24));
          var hou = parseInt(time % (60 * 60 * 24) / 3600);
          var min = parseInt(time % (60 * 60 * 24) % 3600 / 60);
          var sec = parseInt(time % (60 * 60 * 24) % 3600 % 60);
          hou = parseInt(hou) + parseInt(day * 24);
          obj = {
            day: that.timeFormat(day),
            hou: that.timeFormat(hou),
            min: that.timeFormat(min),
            sec: that.timeFormat(sec)
          }
        } else {
          obj = {
            day: '00',
            hou: '00',
            min: '00',
            sec: '00'
          }
        }
        endTimeList[i].time = obj
      }
      that.pink = endTimeList
    },1000);
    that.timeer = timeer
  },
    timeFormat(param) {//小于10的格式化函数
      return param < 10 ? '0' + param : param;
    },
    goCombination(item){
      this.$router.push({
        path:`/activity/goods_combination_status/index?id=${item.id}`
      })
    },
    showAll(){
      if (this.AllIndex > this.pink.length){
        this.AllIndex = this.pink.length;
      }else{
        this.AllIndex+=2;
        this.AllIndex = this.AllIndex;
      }
    },
    hideAll(){
      this.AllIndex = 2
    },
    selecAttr(){
      this.attr.attribute.cartAttr = true
    },
    setOpenShare: function() {
      var data = this.storeInfo;
      var href = location.href;
      if (isWeixin()) {
        if (this.isLogin) {
          getUserInfo().then(res => {
            href =
              href.indexOf("?") === -1
                ? href + "?spread=" + res.data.uid
                : href + "&spread=" + res.data.uid;
            var configAppMessage = {
              desc: data.info,
              title: data.title,
              link: href,
              imgUrl: data.image
            };
            wechatEvevt(
              [
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "onMenuShareAppMessage",
                "onMenuShareTimeline"
              ],
              configAppMessage
            )
              .then(res => {
                console.log(res);
              })
              .catch(res => {
                if (res.is_ready) {
                  res.wx.updateAppMessageShareData(configAppMessage);
                  res.wx.onMenuShareAppMessage(configAppMessage);
                  res.wx.updateTimelineShareData(configAppMessage);
                  res.wx.onMenuShareTimeline(configAppMessage);
                }
              });
          });
        } else {
          
          getUserInfo().then(res =>{
            var configAppMessage = {
            desc: data.info,
            title: data.title,
            link: href,
            imgUrl: data.image
          };
          wechatEvevt(
            [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareAppMessage",
              "onMenuShareTimeline"
            ],
            configAppMessage
          )
            .then(res => {
              console.log(res);
            })
            .catch(res => {
              if (res.is_ready) {
                res.wx.updateAppMessageShareData(configAppMessage);
                res.wx.onMenuShareAppMessage(configAppMessage);
                res.wx.updateTimelineShareData(configAppMessage);
                res.wx.onMenuShareTimeline(configAppMessage);
              }
            });
          })
          
        }
      }
    },
  },
};
</script>
<style scoped>
.assemble-img img {
  width: .6rem;
  height: .6rem;
  margin: .1rem;
  border-radius: 50%;
}
.generate-posters.on {
    transform: translate3d(0, -1rem, 0);
    -webkit-transform: translate3d(0, -1rem, 0);
    -ms-transform: translate3d(0, -1rem, 0);
    -moz-transform: translate3d(0, -1rem, 0);
    -o-transform: translate3d(0, -1rem, 0);
    opacity: 1;
}
.generate-posters {
    width: 100%;
    height: 1.7rem;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    transform: translate3d(0, 100%, 0);
    -webkit-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    -moz-transform: translate3d(0, 100%, 0);
    -o-transform: translate3d(0, 100%, 0);
    transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
    opacity: 0;
}
.generate-posters .item{
    -webkit-box-flex: 50%;
    flex: 50%;
    -webkit-flex: 50%;
    -ms-flex: 50%;
    text-align: center;
}
.generate-posters .item .iconfont{
    font-size: 0.8rem;
    color: #5eae72;
}
.productInfo {
  padding: 0.02rem 0.14rem;
  border-radius: 10px !important;
  font-size: 0.26rem !important;
  font-weight: 500 !important;
  margin-right: 0.2rem !important;
  color: #fff !important;
  background: rgb(201, 151, 92, 0.8);
}
.font-color {
  color: #fc4141 !important;
}
.font-color-fff {
  color: #ffffff !important;
}
.bg-color {
  background-color: #9dccd0 !important;
}
.endtime text {
  display: inline-block;
  margin: 0 0.2rem;
  line-height: 1.6em;
  padding: 0 0.2rem;
  border-radius: 3px;
}
.GoodsCombinationDetails {
  background: #f5f5f5 !important;
}
.product-con .wrapper {
  padding-bottom: 0.26rem;
}
.product-con .wrapper .share .money .y-money {
  color: #82848f;
  margin-left: 0.13rem;
  text-decoration: line-through;
  font-weight: normal;
}
.product-con .notice {
  width: 100%;
  height: 0.62rem;
  background-color: #f5f5f5;
  margin-top: 0.2rem;
  padding: 0 0.3rem;
  box-sizing: border-box;
}
.product-con .notice .num {
  font-size: 0.24rem;
  color: #9dccd0 !important;
}
.product-con .notice .num .iconfont {
  font-size: 0.3rem;
  vertical-align: -0.03rem;
  margin-right: 0.2rem;
}
.product-con .notice .num .line {
  color: #282828;
  margin-left: 0.15rem;
}
.product-con .notice .swiper {
  height: 100%;
  width: 3.6rem;
  line-height: 0.62rem;
  overflow: hidden;
  margin-left: 0.14rem;
}
.product-con .notice .swiper swiper {
  height: 100%;
  width: 100%;
  overflow: hidden;
  font-size: 0.24rem;
  color: #282828;
}
.product-con .assemble {
  background-color: #fff;
}
.product-con .assemble .item {
  padding-right: 0.3rem;
  margin-left: 0.3rem;
  border-bottom: 1px solid #f0f0f0;
  height: 1.32rem;
}
.product-con .assemble .item .pictxt {
  width: 2.56rem;
}
.product-con .assemble .item .pictxt .text {
  width: 1.6rem;
}
.product-con .assemble .item .pictxt .pictrue {
  width: 0.8rem;
  height: 0.8rem;
}
.product-con .assemble .item .pictxt .pictrue image {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
.product-con .assemble .item .right .lack {
  font-size: 0.24rem;
  color: #333333;
}
.product-con .assemble .item .right .time {
  font-size: 0.22rem;
  color: #82848f;
  margin-top: 0.05rem;
}
.product-con .assemble .item .right .spellBnt {
  font-size: 0.24rem;
  color: #fff;
  width: 1.4rem;
  height: 0.5rem;
  border-radius: 25px;
  background: #ff554c;
  text-align: center;
  line-height: 0.5rem;
  margin-left: 0.3rem;
}
.product-con .assemble .item .right .spellBnt .iconfont {
  font-size: 0.25rem;
  margin-left: 0.05rem;
}
.product-con .assemble .more {
  font-size: 0.24rem;
  color: #282828;
  text-align: center;
  height: 0.9rem;
  line-height: 0.9rem;
}
.product-con .assemble .more .iconfont {
  margin-left: 0.13rem;
  font-size: 0.25rem;
}
.product-con .playWay {
  background-color: #fff;
  padding: 0 0.3rem;
  margin-top: 0.2rem;
  font-size: 0.28rem;
  color: #282828;
}
.product-con .playWay .title {
  height: 0.86rem;
  border-bottom: 1px solid #eee;
}
.product-con .playWay .title .iconfont {
  margin-left: 0.13rem;
  font-size: 0.28rem;
  color: #717171;
}
.product-con .playWay .way {
  min-height: 1.1rem;
  font-size: 0.26rem;
  color: #282828;
}
.product-con .playWay .way .iconfont {
  color: #cdcdcd;
  font-size: 0.4rem;
  margin: 0 0.35rem;
}
.product-con .playWay .way .item .num {
  font-size: 0.35rem;
  vertical-align: 0.03rem;
  margin-right: 0.06rem;
}
.product-con .playWay .way .item .tip {
  font-size: 0.22rem;
  color: #a5a5a5;
  margin-top: 0.07rem;
}
.product-con .footer {
  padding: 0 0.2rem 0 0.3rem;
  position: fixed;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  height: 1rem;
  background-color: #fff;
  z-index: 999999;
  border-top: 1px solid #f0f0f0;
}
.product-con .footer .item {
  font-size: 0.18rem;
  color: #666;
}
.product-con .footer .item .iconfont {
  text-align: center;
  font-size: 0.4rem;
}
.product-con .footer .item .iconfont.icon-shoucang1 {
  color: #f00;
}
.product-con .footer .item .iconfont.icon-gouwuche1 {
  font-size: 0.4rem;
  position: relative;
}
.product-con .footer .item .iconfont.icon-gouwuche1 .num {
  color: #fff;
  position: absolute;
  font-size: 0.18rem;
  padding: 0.02rem 0.08rem 0.03rem;
  border-radius: 100px;
  top: -0.1rem;
  right: -0.1rem;
}
.product-con .footer .bnt {
  width: 5.4rem;
  height: 0.76rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.product-con .footer .bnt .bnts {
  width: 1.8rem;
  height: 0.6rem;
  text-align: center;
  line-height: 0.6rem;
  color: #fff;
  font-size: 0.28rem;
  margin-left: 0.2rem;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.16);
}
.product-con .footer .bnt .joinCart {
  border-radius: 25px;
  background: #9dccd0;
  border: none;
}
.product-con .footer .bnt .buy {
  border-radius: 25px;
  background: #9dccd0;
}
.setCollectBox {
  font-size: 0.18rem;
  color: #666;
}

/* ackerman */
.product-con {
  box-sizing: border-box;
  padding: 0 0.3rem;
  border-radius: 5px;
}
.product-con .wrapper .introduce {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 0.46rem 0 0.23rem;
}
.product-con .notice,
.product-con .playWay,
.product-con .product-intro {
  margin-top: 0 !important;
}
.product-con .playWay {
  display: none;
}
.product-con .product-intro {
  background: #ffffff;
}
.product-con .product-intro .conter {
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 0.3rem 0.3rem;
}
.product-con .assemble {
  padding: 0.2rem;
}
.product-con .assemble-child {
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
}
.endtime {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.2rem 0;
}
.endtime span {
  display: inline-block;
  margin: 0 0.2rem;
  line-height: 1.6em;
  padding: 0 0.2rem;
  border-radius: 3px;
}
.product-con .footer {
  left: 0;
}
.assemble-img {
  box-sizing: border-box;
  padding: 0.3rem;
  background: #fff;
}
.assemble-img-child {
  border: 1px dashed #ff6d40;
  padding: 0.3rem;
  border-radius: 10px;
}
.assemble-img span {
  display: block;
  font-size: 0.9em;
  font-weight: 300;
  text-align: center;
}
.assemble-img .assemble-head-img {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.assemble-img image {
  width: 0.6rem;
  height: 0.6rem;
  margin: 0.1rem;
  border-radius: 50%;
}
.bg-fff {
  background: #fff;
  padding-top: 0.2rem;
}
</style>